import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  TextField,
  InputProps,
} from "@mui/material";
import moment from "moment-timezone";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ClipLoader } from "react-spinners";

import app from "../../utils/firebase";
import { ref, set } from "firebase/database";

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import Swal from "sweetalert2";
import YoutubeEmbed from "./youtubeEmbed";

// core components
import GalleryPageHeader from "components/Headers/GalleryPageHeader.js";
import Navbar from "components/Navbars/Navbar.js";
import SubHeader from "components/Headers/SubHeaderBanner";
import DarkFooter from "components/Footers/DarkFooter.js";
import PanelCountdown from "components/PanelCountdown";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import "./style.scss";
import DtPicker from "react-calendar-datetime-picker";
import "react-calendar-datetime-picker/dist/index.css";

// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateRangePicker } from '@mui/x-date-pickers/DateRangePicker';
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import Modal from "react-modal";
import backdrop from "assets/img/gallery/2026/logo-2026.png";

const style = {
  noBorder: {
    border: "none",
  },
  root: {
    borderColor: "orange",
  },
};

function Macau() {
  const db = app();

  const [selectedDate, handleDateChange] = useState(new Date());

  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const items = [
    {
      src: require("assets/img/gallery/2026/registration/90.jpg"),
      caption: "Onsite Registration",
      relatedRange: [1, 92],
      path: "/2026/registration",
    },
    {
      src: require("assets/img/gallery/2026/joyride-dinner/1.jpg"),
      caption: "FIBS Welcome Cheers @ Joyride",
      relatedRange: [1, 106],
      path: "/2026/joyride-dinner",
    },
    {
      src: require("assets/img/gallery/2026/speed-circuit/83.jpg"),
      caption: "FIBS Speed Circuit",
      relatedRange: [1, 90],
      path: "/2026/speed-circuit",
    },
    {
      src: require("assets/img/gallery/2026/panel-discussion/2.jpg"),
      caption: "Panel Discussion",
      relatedRange: [1, 143],
      path: "/2026/panel-discussion",
    },
    {
      src: require("assets/img/gallery/2026/rocks-hotel/108.jpg"),
      caption: "FIBS Taste of Portugal at Rocks Hotel",
      relatedRange: [1, 122],
      path: "/2026/rocks-hotel",
    },
    {
      src: require("assets/img/gallery/2026/face-to-face/22.jpg"),
      caption: "Face to Face Meetings",
      relatedRange: [1, 73],
      path: "/2026/face-to-face",
    },
    {
      src: require("assets/img/gallery/2026/macau-tour/125.jpg"),
      caption: "FIBS Macau City Explorer",
      relatedRange: [1, 264],
      path: "/2026/macau-tour",
    },
    {
      src: require("assets/img/gallery/2026/mop-bar/1.jpg"),
      caption: "The FIBS Eclipse @ MOP",
      relatedRange: [1, 102],
      path: "/2026/mop-bar",
    },
    {
      src: require("assets/img/gallery/2026/finale/1.jpg"),
      caption: "The Finale – Chill & Cheers",
      relatedRange: [1, 100],
      path: "/2026/finale",
    },
  ];

  const generateImageURLs = (range, path) => {
    const [start, end] = range;
    const urls = [];
    for (let i = start; i <= end; i++) {
      urls.push(`${path}/${i}.jpg`);
    }
    return urls;
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [galleryCaption, setGalleryCaption] = useState("");

  const openModal = (range, path, caption) => {
    const relatedImages = generateImageURLs(range, path);
    setGalleryCaption(caption);
    setCurrentImages(relatedImages);
    setLoading(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentImages([]);
    setLoading(false);
  };

  return (
    <>
      <Navbar />
      <GalleryPageHeader
        photoCover={require("assets/img/gallery/2026/group-photo.jpg")}
      />
      {/* 
      <div className="banner-container">
        <div
          className="banner-image"
          style={{
            backgroundImage: `url(${backdrop})`,
          }}
        ></div>
      </div> */}
      <div className="wrapper position-relative">
        <div className="main my-5">
          <section className="section gb nopadtop">
            <div className="container">
              <div className="boxed boxedp4">
                <div className="row">
                  <div className="col-md-12 section-title text-center">
                    <h2 className="font-weight-bold mb-2">
                      {" "}
                      FIBS Global Conference Post-Event 2026
                    </h2>
                    <h3 className="fs-5 w-lg-60 mb-0 mx-auto ">
                      Studio City, Macau
                    </h3>
                    <h4 className="my-2">March 03 - 06, 2026 </h4>
                  </div>
                </div>

                <div className="col-md-12 mb-5">
                  <div className="my-1">
                    <div className="grid-container-video mt-5">
                      <YoutubeEmbed
                        embedId="xmpmxYHODRI"
                        title={"2026 Day 1 - FIBS Global Conference | Macau"}
                      />
                      <YoutubeEmbed
                        embedId="nGKUQ5kyzqg"
                        title={
                          "2026 Day 2 - FIBS Global Conference | Macau - Part 1"
                        }
                      />
                      <YoutubeEmbed
                        embedId="mlyqFttJMTc"
                        title={
                          "2026 Day 2 - FIBS Global Conference | Macau - Part 2"
                        }
                      />
                      <YoutubeEmbed
                        embedId="v0NNhEgMFoE"
                        title={
                          "2026 Day 3 - FIBS Global Conference | Macau - Part 1"
                        }
                      />
                      <YoutubeEmbed
                        embedId="hR4o8p6PscA"
                        title={
                          "2026 Day 3 - FIBS Global Conference | Macau - Part 2"
                        }
                      />
                      <YoutubeEmbed
                        embedId="rgyby--JXZ4"
                        title={"2026 Day 4 - FIBS Global Conference | Macau"}
                      />
                    </div>

                    <hr className="mb-4 mt-4" />

                    <div className="grid-container">
                      {items.map((item, index) => (
                        <div
                          key={index}
                          className="grid-item bg-white shadow px-2 pt-2 pb-3 gallery-image"
                        >
                          <img
                            src={item.src}
                            alt={`Image ${index + 1}`}
                            onClick={() =>
                              openModal(
                                item.relatedRange,
                                item.path,
                                item.caption,
                              )
                            }
                            onLoad={() => setLoading(false)}
                            style={{
                              cursor: "pointer",
                              margin: "10px",
                              display: loading ? "none" : "block",
                            }}
                          />
                          <div className="caption1">
                            <p className="mb-0"> {item.caption} </p>
                          </div>
                          {loading && (
                            <div className="loader">
                              <ClipLoader
                                color={"#123abc"}
                                loading={loading}
                                size={150}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Dialog maxWidth="lg" open={modalIsOpen} onClose={closeModal}>
            <DialogTitle className="bg-danger text-white">
              FIBS {galleryCaption}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <div className="grid-container">
                {currentImages.map((img, index) => (
                  <div className="grid-item bg-white shadow px-2 gallery-image">
                    {/* <img key={index} src={require(`assets/img/gallery${img}`)} onLoad={() => setLoading(false)} alt="Related" style={{ margin: '10px' }} />
                    {loading && (
                      <div className="gallery-image loader">
                          <ClipLoader color={'#123abc'} loading={loading} size={250} />
                      </div>
                    )} */}

                    <ImageWithLoader
                      key={index}
                      src={require(`assets/img/gallery${img}`)}
                      alt="related"
                      width="400px"
                      height="300px"
                    />
                  </div>
                ))}
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

const ImageWithLoader = ({ src, alt, width = "300px", height = "200px" }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className="image-container gallery-image" style={{ width, height }}>
      {loading && <div className="loader"></div>}
      <img
        src={src}
        alt={alt}
        className={`image ${loading ? "hidden" : ""}`}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default Macau;
